import createClient from 'openapi-fetch'

import { type paths } from './schema' // (generated from openapi-typescript)

const { REACT_APP_NEURALITY_URL } = process.env

export const { get, post, put } = createClient<paths>({
  baseUrl: REACT_APP_NEURALITY_URL,
})
